import React, { useState } from 'react';

import Button from '~/components/button';
import { useFlashMessage } from '~/features/flash-messages/flash-message-actions';
import { useCartMutations } from '~/features/cart/cart-actions';
import { captureException } from '~/utils/exception-tracking';

import modalStyles from '~/components/modals/modal.module.scss';

const ShipNow = ({ onClose, shipment }) => {
  const { updateProcessDate } = useCartMutations();
  const { showFlashMessage } = useFlashMessage();
  const [isScheduling, setIsScheduling] = useState(false);

  const handleClick = async () => {
    try {
      setIsScheduling(true);
      const processDate = new Date();
      processDate.setUTCHours(12, 0, 0, 0);

      const isoProcessDate = processDate.toISOString();

      await updateProcessDate({
        cartUuid: shipment.uuid,
        processDate: isoProcessDate,
      });
      showFlashMessage('Your shipment is scheduled.', 'success');
      setIsScheduling(false);
      onClose();
    } catch (err) {
      captureException(new Error('Transmit now failed.'), {
        extras: {
          error: JSON.stringify(err),
          poUuid: shipment.uuid,
        },
      });
      showFlashMessage(
        'Oops, there was an issue updating your shipment. Please try again later.'
      );
      setIsScheduling(false);
    }
  };

  return (
    <div className={modalStyles.shipNow}>
      <h2>Ready to ship now?</h2>
      <img
        src="/icons/shipping-truck-icon.svg"
        alt="Shipping truck icon"
        className={modalStyles.shipNowIcon}
        height={46}
        width={64}
      />
      <p>Your items will ship within 1-3 business days.</p>
      <p>Would you like to proceed?</p>
      <div className={modalStyles.buttonWrapper}>
        <Button
          fullWidth
          onClick={onClose}
          variant="transparentGreen"
          data-heap-id="ship-now-no-button"
          isLoading={isScheduling}
        >
          No
        </Button>
        <Button
          fullWidth
          className={modalStyles.confirmButton}
          onClick={handleClick}
          data-heap-id="ship-now-confirm-button"
          isLoading={isScheduling}
        >
          Yes
        </Button>
      </div>
    </div>
  );
};

export default ShipNow;
